import { render, staticRenderFns } from "./Procedure_edit.vue?vue&type=template&id=b71717a8&"
import script from "./Procedure_edit.vue?vue&type=script&lang=js&"
export * from "./Procedure_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports